<!--
 * @Author: p_fy
 * @Date: 2019-06-19 16:02:51
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 18:28:03
 * @Description: 仓库供给发布页面，页面：普仓、罐区
 -->
<template>
  <div>
    <div class="main-wrap">
      <div style="padding-top: 10px;" class="menu-head">
        <div style="width: 100%;">
          <el-tabs v-model="activeName" v-loading="loading" @tab-click="handleClick">
            <el-tab-pane label="普仓供给发布" name="first">
              <div class="first-error">
                <div id="container" style="width:100px;height: 100px;display: none;" />
                <div id="panel" />
                <el-form
                  ref="storageSupply"
                  :rules="storageSupplyRules"
                  :model="storageSupply"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item v-input-filter label="租单名称" prop="supplyName">
                        <el-input v-model="storageSupply.supplyName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="仓库类型" prop="warehouseType">
                        <el-select v-model="storageSupply.warehouseType" warehouse-type="请选择">
                          <el-option v-for="city in storageType.warehouseType" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="起租日期" prop="leaseTime">
                        <el-date-picker
                          v-model="storageSupply.leaseTime"
                          :editable="false"
                          type="date"
                          :picker-options="pickerOptions"
                          placeholder="选择日期"
                          style="width: 100%;"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="储存品类" prop="storageType">
                        <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">不限</el-checkbox>
                        <el-checkbox-group v-model="storageSupply.storageType" @change="handleCheckedCitiesChange">
                          <el-checkbox v-for="city in storageType.storageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="建筑面积" prop="coveredArea">
                        <el-input v-model="storageSupply.coveredArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="起租年限" prop="leaseTerm">
                        <el-select v-model="storageSupply.leaseTerm" style="width:100%;" placeholder="请选择起租年限">
                          <el-option v-for="city in storageType.leaseTerm" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="storageSupply.fireQualification" placeholder="请选择消防资质">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="租金" prop="expectPrice">
                        <el-input v-model="storageSupply.expectPrice">
                          <template slot="append">元/㎡/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          ref="addressRelease"
                          v-model="storageSupply.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          class="storageLocation"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="详细位置" class="detailedLocation" prop="detailedLocation">
                        <el-input v-model="storageSupply.detailedLocation"  placeholder="请输入内容"  popper-class="my-autocomplete"   :fetch-suggestions="querySearch">
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div> 
                          <!-- <span class="addr">{{ item.address }}</span> -->
                         </template>
                        </el-input>
                        <!-- <el-autocomplete
                          v-model="storageSupply.detailedLocation"
                          popper-class="my-autocomplete"
                          :fetch-suggestions="querySearch"
                          placeholder="请输入内容"
                          style="width: 100%;"
                          @select="handleSelect"
                        >
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div> -->
                            <!--<span class="addr">{{ item.address }}</span>-->
                          <!-- </template>
                        </el-autocomplete> -->
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="可租用面积" prop="rentableArea">
                        <el-input v-model="storageSupply.rentableArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="起租面积" prop="lettableArea">
                        <el-input v-model="storageSupply.lettableArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库内设备" prop="warehouseEquipment">
                        <el-select v-model="storageSupply.warehouseEquipment" multiple placeholder="请选择">
                          <el-option v-for="city in storageType.storeEquipment" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地坪质地" prop="floorTexture">
                        <el-select v-model="storageSupply.floorTexture" placeholder="请选择地坪质地">
                          <el-option v-for="city in storageType.floorTexture" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="地坪承重" prop="floorWeight">
                        <el-input v-model="storageSupply.floorWeight">
                          <template slot="append">吨/㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="卸货平台" prop="landingPlatform">
                        <el-select v-model="storageSupply.landingPlatform" placeholder="请选择卸货平台">
                          <el-option v-for="city in storageType.landingPlatform" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="库房照片" prop="storageUrl">
                        <g-upload :limit="6" is-edit :max-size="1" :method-name="authenticationFile" :multiple="true" :img-list.sync="storageSupply.storageUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="storageSupply.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="storageSupply.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="storageSupply.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="仓库简介" prop="storageRecommend">
                        <el-input v-model="storageSupply.storageRecommend" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" size="small" @click="storageSupplySave('storageSupply',2)">发布</el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="普仓供给保存" name="sencond">
              <div class="sencond-error">
                <div id="container" style="width:100px;height: 100px;display: none;" />
                <div id="panel" />

                <!-- 非必选的验证 -->
                <el-form
                  ref="storageNoRequireSupply"
                  :rules="storageSupplyNoRequireRules"
                  :model="storageSupply"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item v-input-filter label="租单名称" prop="supplyName">
                        <el-input v-model="storageSupply.supplyName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="仓库类型" prop="warehouseType">
                        <el-select v-model="storageSupply.warehouseType" warehouse-type="请选择">
                          <el-option v-for="city in storageType.warehouseType" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="起租日期" prop="leaseTime">
                        <el-date-picker
                          v-model="storageSupply.leaseTime"
                          :editable="false"
                          type="date"
                          :picker-options="pickerOptions"
                          placeholder="选择日期"
                          style="width: 100%;"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="储存品类" prop="storageType">
                        <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">不限</el-checkbox>
                        <el-checkbox-group v-model="storageSupply.storageType" @change="handleCheckedCitiesChange">
                          <el-checkbox v-for="city in storageType.storageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="建筑面积" prop="coveredArea">
                        <el-input v-model="storageSupply.coveredArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="起租年限" prop="leaseTerm">
                        <el-select v-model="storageSupply.leaseTerm" style="width:100%;" placeholder="请选择起租年限">
                          <el-option v-for="city in storageType.leaseTerm" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="storageSupply.fireQualification" placeholder="请选择消防资质">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="租金" prop="expectPrice">
                        <el-input v-model="storageSupply.expectPrice">
                          <template slot="append">元/㎡/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          v-model="storageSupply.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          class="storageLocation"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="详细位置" class="detailedLocation" prop="detailedLocation">
                        <el-input v-model="storageSupply.detailedLocation"  placeholder="请输入内容"  popper-class="my-autocomplete"   :fetch-suggestions="querySearch">
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div> 
                          <!-- <span class="addr">{{ item.address }}</span> -->
                         </template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="可租用面积" prop="rentableArea">
                        <el-input v-model="storageSupply.rentableArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="起租面积" prop="lettableArea">
                        <el-input v-model="storageSupply.lettableArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库内设备" prop="warehouseEquipment">
                        <el-select v-model="storageSupply.warehouseEquipment" multiple placeholder="请选择">
                          <el-option v-for="city in storageType.storeEquipment" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地坪质地" prop="floorTexture">
                        <el-select v-model="storageSupply.floorTexture" placeholder="请选择地坪质地">
                          <el-option v-for="city in storageType.floorTexture" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="地坪承重" prop="floorWeight">
                        <el-input v-model="storageSupply.floorWeight">
                          <template slot="append">吨/㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="卸货平台" prop="landingPlatform">
                        <el-select v-model="storageSupply.landingPlatform" placeholder="请选择卸货平台">
                          <el-option v-for="city in storageType.landingPlatform" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="库房照片" prop="storageUrl">
                        <g-upload :limit="6" is-edit :max-size="1" :method-name="authenticationFile" :multiple="true" :img-list.sync="storageSupply.storageUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="storageSupply.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="storageSupply.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="storageSupply.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="仓库简介" prop="storageRecommend">
                        <el-input v-model="storageSupply.storageRecommend" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" plain size="small" @click="storageSupplySave('storageNoRequireSupply',1)">保存</el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>

            <el-tab-pane label="罐区供给发布" name="there"><div>
              <div class="there-error">
                <!-- 非必选表单 -->
                <el-form
                  ref="tankFarmSupply"
                  :rules="tankFarmSupplyRules"
                  :model="tankFarmSupply"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item v-input-filter label="租单名称" prop="supplyName">
                        <el-input v-model="tankFarmSupply.supplyName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="储罐形状" prop="storageTankShape">
                        <el-select v-model="tankFarmSupply.storageTankShape" placeholder="请选择">
                          <el-option v-for="city in storageType.storageTankShape" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="起租日期" prop="leaseTime">
                        <el-date-picker
                          v-model="tankFarmSupply.leaseTime"
                          :editable="false"
                          type="date"
                          :picker-options="pickerOptions"
                          placeholder="选择日期"
                          style="width: 100%;"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="储存品类" prop="storageType">
                        <el-checkbox-group v-model="tankFarmSupply.storageType">
                          <el-checkbox v-for="city in storageType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="货物名称" prop="cargoName">
                        <el-input v-model="tankFarmSupply.cargoName" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="储罐规格" prop="storageTankStandard">
                        <el-input v-model="tankFarmSupply.storageTankStandard">
                          <template slot="append">m³</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="储罐高度" prop="storageTankHeight">
                        <el-input v-model="tankFarmSupply.storageTankHeight">
                          <template slot="append">米</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="储罐直径" prop="storageTankDiameter">
                        <el-input v-model="tankFarmSupply.storageTankDiameter">
                          <template slot="append">米</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="储罐型号" prop="storageTankType">
                        <el-select v-model="tankFarmSupply.storageTankType" placeholder="请选择">
                          <el-option v-for="city in storageType.storageTankType" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="可租罐数" prop="tenantablePotCount">
                        <el-input v-model="tankFarmSupply.tenantablePotCount">
                          <template slot="append">个</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="起租罐数" prop="leasePotCount">
                        <el-input v-model="tankFarmSupply.leasePotCount">
                          <template slot="append">个</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="租金" prop="expectPrice">
                        <el-input v-model="tankFarmSupply.expectPrice">
                          <template slot="append">元/罐/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="起租年限" prop="leaseTerm">
                        <el-select v-model="tankFarmSupply.leaseTerm" placeholder="请选择">
                          <el-option v-for="city in storageType.leaseTerm" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="tankFarmSupply.fireQualification" placeholder="请选择">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          v-model="tankFarmSupply.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          class="tankStorageLocation"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="详细位置" class="tankDetailedLocation" prop="detailedLocation">
                        <!-- <el-autocomplete
                          v-model="tankFarmSupply.detailedLocation"
                          popper-class="my-autocomplete"
                          :fetch-suggestions="querySearch"
                          placeholder="请输入内容"
                          style="width: 100%;"
                          @select="handleSelect"
                        >
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div>
                            <--<span class="addr">{{ item.address }}</span>-->
                          <!-- </template>
                        </el-autocomplete> -->
                        <el-input v-model="tankFarmSupply.detailedLocation"  placeholder="请输入内容"  popper-class="my-autocomplete"   :fetch-suggestions="querySearch">
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div> 
                          <!-- <span class="addr">{{ item.address }}</span> -->
                         </template>
                        </el-input>



                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="罐区面积" prop="potArea">
                        <el-input v-model="tankFarmSupply.potArea" v-input-filter>
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="罐区耐火等级" prop="fireResistanceRating">
                        <el-select v-model="tankFarmSupply.fireResistanceRating" placeholder="请选择罐区耐火等级">
                          <el-option v-for="city in storageType.fireResistanceRating" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="24">
                      <el-form-item v-input-filter label="消防信息" prop="fireInformation">
                        <el-input v-model="tankFarmSupply.fireInformation" />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="罐区照片" prop="storageUrl">
                        <g-upload :limit="6" is-edit :max-size="1" :method-name="authenticationFile" :multiple="true" :img-list.sync="tankFarmSupply.storageUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="tankFarmSupply.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="tankFarmSupply.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="tankFarmSupply.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="罐区简介" prop="remarks">
                        <el-input v-model="tankFarmSupply.remarks" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" size="small" @click="tankFarmSupplySave('tankFarmSupply',2)">发布</el-button>
                  </div>
                </el-form>
              </div>
            </div>
            </el-tab-pane>
            <el-tab-pane label="罐区供给保存" name="four"><div>
              <div class="four-error">
                <!-- 非必选表单 -->
                <el-form
                  ref="tankFarmNoRequireSupply"
                  :rules="tankFarmSupplyNoRequireRules"
                  :model="tankFarmSupply"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item v-input-filter label="租单名称" prop="supplyName">
                        <el-input v-model="tankFarmSupply.supplyName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="储罐形状" prop="storageTankShape">
                        <el-select v-model="tankFarmSupply.storageTankShape" placeholder="请选择">
                          <el-option v-for="city in storageType.storageTankShape" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="起租日期" prop="leaseTime">
                        <el-date-picker
                          v-model="tankFarmSupply.leaseTime"
                          :editable="false"
                          type="date"
                          :picker-options="pickerOptions"
                          placeholder="选择日期"
                          style="width: 100%;"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="储存品类" prop="storageType">
                        <el-checkbox-group v-model="tankFarmSupply.storageType">
                          <el-checkbox v-for="city in storageType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="货物名称" prop="cargoName">
                        <el-input v-model="tankFarmSupply.cargoName" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="储罐规格" prop="storageTankStandard">
                        <el-input v-model="tankFarmSupply.storageTankStandard">
                          <template slot="append">m³</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="储罐高度" prop="storageTankHeight">
                        <el-input v-model="tankFarmSupply.storageTankHeight">
                          <template slot="append">米</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="储罐直径" prop="storageTankDiameter">
                        <el-input v-model="tankFarmSupply.storageTankDiameter">
                          <template slot="append">米</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="储罐型号" prop="storageTankType">
                        <el-select v-model="tankFarmSupply.storageTankType" placeholder="请选择">
                          <el-option v-for="city in storageType.storageTankType" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="可租罐数" prop="tenantablePotCount">
                        <el-input v-model="tankFarmSupply.tenantablePotCount">
                          <template slot="append">个</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item v-input-filter label="起租罐数" prop="leasePotCount">
                        <el-input v-model="tankFarmSupply.leasePotCount">
                          <template slot="append">个</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-input-filter label="租金" prop="expectPrice">
                        <el-input v-model="tankFarmSupply.expectPrice">
                          <template slot="append">元/罐/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="起租年限" prop="leaseTerm">
                        <el-select v-model="tankFarmSupply.leaseTerm" placeholder="请选择">
                          <el-option v-for="city in storageType.leaseTerm" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="tankFarmSupply.fireQualification" placeholder="请选择">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          v-model="tankFarmSupply.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          class="tankStorageLocation"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="详细位置" class="tankDetailedLocation" prop="detailedLocation">
                        <!-- <el-autocomplete
                          v-model="tankFarmSupply.detailedLocation"
                          popper-class="my-autocomplete"
                          :fetch-suggestions="querySearch"
                          placeholder="请输入内容"
                          style="width: 100%;"
                          @select="handleSelect"
                        >
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div>
                            <--<span class="addr">{{ item.address }}</span>-->
                          <!-- </template>
                        </el-autocomplete> -->
                        <el-input v-model="tankFarmSupply.detailedLocation"  placeholder="请输入内容"  popper-class="my-autocomplete"   :fetch-suggestions="querySearch">
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div> 
                          <!-- <span class="addr">{{ item.address }}</span> -->
                         </template>
                        </el-input>



                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="罐区面积" prop="potArea">
                        <el-input v-model="tankFarmSupply.potArea" v-input-filter>
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="罐区耐火等级" prop="fireResistanceRating">
                        <el-select v-model="tankFarmSupply.fireResistanceRating" placeholder="请选择罐区耐火等级">
                          <el-option v-for="city in storageType.fireResistanceRating" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="24">
                      <el-form-item v-input-filter label="消防信息" prop="fireInformation">
                        <el-input v-model="tankFarmSupply.fireInformation" />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="罐区照片" prop="storageUrl">
                        <g-upload :limit="6" is-edit :max-size="1" :method-name="authenticationFile" :multiple="true" :img-list.sync="tankFarmSupply.storageUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="tankFarmSupply.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="tankFarmSupply.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="tankFarmSupply.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="罐区简介" prop="remarks">
                        <el-input v-model="tankFarmSupply.remarks" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" plain size="small" @click="tankFarmSupplySave('tankFarmNoRequireSupply',1)">保存</el-button>
                  </div>
                </el-form>
              </div>
            </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">

import AMap from 'AMap' // 引入高德地图
// 引用数据
import { createInfo, createTankFarmInfo, getArea, getDict, getCompanyInfo } from '@/api/personal/store/publish-supply/publishSupply'

import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
export default {
  name: 'PublishSupply',
  data: function() {
    // 可租用面积校验方法
    var rentableArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入可租用面积'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (!this.storageSupply.coveredArea) {
            return callback(new Error('请先输入建筑面积'))
          } else {
            if (parseFloat(this.storageSupply.coveredArea) < parseFloat(value)) {
              return callback(new Error('可租用面积超出范围(不得超出建筑面积)'))
            } else {
              if (value != 0 && value.length < 11 && number.reg.test(value)) {
                callback()
              } else {
                callback(new Error(number.title))
              }
            }
          }
        }
      }
    }
    // 租金校验方法
    var expectPrice = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入租金'))
      } else {
        if (value != 0 && value.length < 11 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }

    // 地坪承重校验方法
    var floorWeight = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入地坪承重'))
      } else {
        if (value != 0 && value.length < 11 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 建筑面积校验方法
    var coveredArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入建筑面积'))
      } else {
        if (value != 0 && value.length < 11 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 起租面积校验方法
    var lettableArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入起租面积'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (!this.storageSupply.rentableArea) {
            return callback(new Error('请先输入可租用面积'))
          } else {
            if (parseFloat(this.storageSupply.rentableArea) < parseFloat(value)) {
              return callback(new Error('起租面积超出范围(不得超出可租用面积)'))
            } else {
              if (value != 0 && value.length < 11 && number.reg.test(value)) {
                callback()
              } else {
                callback(new Error(number.title))
              }
            }
          }
        }
      }
    }

    // 储罐规格校验方法
    var storageTankStandard = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入储罐规格'))
      } else {
        if (value != 0 && value.length < 11 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 储罐直径校验方法
    var storageTankDiameter = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入储罐直径'))
      } else {
        if (value != 0 && value.length < 11 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 储罐高度校验方法
    var storageTankHeight = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入储罐高度'))
      } else {
        if (value != 0 && value.length < 11 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 罐区面积校验方法
    var potArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入罐区面积'))
      } else {
        if (value != 0 && value.length < 11 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 起租罐数校验方法
    var leasePotCount = (rule, value, callback) => {
      const number = {
        reg: /^[1-9]{1}[0-9]*$/,
        title: '请输入正确内容(正数)'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入起租罐数'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (!this.tankFarmSupply.tenantablePotCount) {
            return callback(new Error('请先输入可租罐数'))
          } else {
            if (parseFloat(this.tankFarmSupply.tenantablePotCount) < parseFloat(value)) {
              return callback(new Error('起租罐数超出范围(不得超出可租罐数)'))
            } else {
              callback()
            }
          }
        }
      }
    }
    // 可租罐数校验方法
    var tenantablePotCount = (rule, value, callback) => {
      const number = {
        reg: /^[1-9]{1}[0-9]*$/,
        title: '请输入正确内容(正数)'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入可租罐数'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          callback()
        }
      }
    }
    return {
      imageUrl: '',
      activeName: 'first',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      loading: true,
      post_flag: false,
      checkAll: false,
      isIndeterminate: true,
      authenticationFile: 'cangchuFile',
      area: [],
      storageType: {
        storageType: [],
        warehouseType: [],
        fireQualification: [],
        storeEquipment: [],
        floorTexture: [],
        landingPlatform: [],
        fireResistanceRating: [],
        tankType: [],
        storageTankShape: [],
        storageTankType: [],
        leaseTerm: []
      },
      storageSupply: {
        supplyName: null, // 租单名称
        warehouseType: null, // 仓库类型
        storageType: [], // 储货类型
        leaseTime: null, // 起租日期
        lettableArea: null, // 起租面积
        rentableArea: null, // 可租用面积
        expectPrice: null, // 租金
        leaseTerm: null, // 起租年限
        storageLocation: null, // 库房位置
        detailedLocation: null, // 详细位置
        coveredArea: null, // 建筑面积
        fireQualification: null, // 消防资质
        warehouseEquipment: null, // 库内设备（多选）
        floorTexture: null, // 地坪质地
        floorWeight: null, // 地坪承重
        landingPlatform: null, // 卸货平台
        storageUrl: '', // 库房照片
        companyId: '212', // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageRecommend: null, // 仓库简介
        remarks: null, // 备注
        publishStatus: null, // 发布状态 1待发布 2已发布,
        longLat: ''
      },
      tankFarmSupply: {
        supplyName: null, // 租单名称
        storageTankShape: null, // 储罐形状
        storageType: [], // 储存类型
        cargoName: null, // 货物名称
        leaseTime: null, // 起租日期
        companyId: '2', // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageTankStandard: null, // 储罐规格
        storageTankHeight: null, // 储罐高度
        storageTankDiameter: null, // 储罐直径
        storageTankType: null, // 储罐型号
        leasePotCount: null, // 起租罐数
        tenantablePotCount: null, // 可租罐数
        expectPrice: null, // 租金
        leaseTerm: null, // 起租年限
        storageLocation: null, // 库房位置
        detailedLocation: null, // 详细位置
        potArea: null, // 罐区面积
        fireResistanceRating: null, // 罐区耐火级
        fireQualification: null, // 消防资质
        fireInformation: null, // 消防信息
        storageUrl: '', // 库房照片(最多可上传6张)
        remarks: null, // 备注
        publishStatus: null, // 发布状态 1已发布 2未发布
        longLat: ''
      }, // 定义弹框对象
      storageSupplyNoRequireRules: { //  非必选验证规则
        supplyName: [{ validator: this.$character(0, 50, 'checkEmpty'), trigger: 'blur' }], // 租单名称
        lettableArea: [{ validator: lettableArea, trigger: 'blur', required: false }], // 起租面积
        rentableArea: [{ validator: rentableArea, trigger: 'blur', required: false }], // 可租用面积
        expectPrice: [{ validator: expectPrice, trigger: 'blur', required: false }], // 租金
        coveredArea: [{ validator: coveredArea, trigger: 'blur', required: false }], // 建筑面积
        floorWeight: [{ validator: floorWeight, trigger: 'blur', required: false }], // 地坪承重
        linkMan: [{ validator: this.$character(0, 20, 'checkEmpty'), trigger: 'blur', required: false }], // 联系人
        telephone: [{ validator: this.$validate('phone'), trigger: 'blur', required: false }], // 手机号
        storageRecommend: [{ validator: this.$character(0, 200, 'checkEmpty'), trigger: 'blur', required: false }] // 仓库简介
      },
      storageSupplyRules: {
        supplyName: [{ required: true, validator: this.$character(0, 50, 'check'), trigger: 'blur' }], // 租单名称
        warehouseType: [{ required: true, message: '请选择仓库类型', trigger: 'change' }], // 仓库类型
        storageType: [{ type: 'array', required: true, message: '请至少选择一个储存类型', trigger: 'change' }], // 储存类型
        leaseTime: [{ required: true, message: '请选择起租日期', trigger: 'change' }], // 起租日期
        lettableArea: [{ required: true, validator: lettableArea }], // 起租面积
        rentableArea: [{ required: true, validator: rentableArea }], // 可租用面积
        expectPrice: [{ required: true, validator: expectPrice }], // 租金
        leaseTerm: [{ required: true, message: '请选择起租年限', trigger: 'change' }], // 起租年限
        storageLocation: [{ required: true, message: '请选择库房位置', trigger: 'change' }], // 库房位置
        detailedLocation: [
          { required: true, message: '请输入详细位置', trigger: 'blur' },
          { max: 255, message: '最多255位字符' }
        ], // 详细位置
        coveredArea: [{ required: true, validator: coveredArea }], // 建筑面积
        fireQualification: [{ required: true, message: '请选择消防资质', trigger: 'change' }], // 消防资质
        warehouseEquipment: [{ required: true, message: '请选择库内设备', trigger: 'blur' }], // 库内设备（多选）
        floorTexture: [{ required: true, message: '请选择地坪质地', trigger: 'change' }], // 地坪质地
        floorWeight: [{ required: true, validator: floorWeight }], // 地坪承重
        landingPlatform: [{ required: true, message: '请选择卸货平台', trigger: 'change' }], // 卸货平台
        storageUrl: [
          // { required: true, message: '请上传库房照片', trigger: 'blur' }
        ], // 库房照片
        companyName: [{ required: true, message: '未认证、请先认证个人信息', trigger: 'blur' }], // 公司名称
        linkMan: [{ required: true, validator: this.$character(0, 20, 'check'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        storageRecommend: [{ required: true, validator: this.$character(1, 200, 'check'), trigger: 'blur' }] // 仓库简介
      },
      tankFarmSupplyNoRequireRules: {
        supplyName: [{ validator: this.$character(0, 50, 'checkEmpty'), trigger: 'blur' }], // 租单名称
        cargoName: [
          { validator: this.$character(0, 50, 'checkEmpty'), trigger: 'blur' }
          // { max: 20, message: '最多20个字符' },
          // { validator: this.$validate('phone'), trigger: 'blur' }
        ], // 货物名称
        linkMan: [{ validator: this.$character(0, 50, 'checkEmpty'), trigger: 'blur' }], // 联系人
        telephone: [{ validator: this.$validate('phone'), trigger: 'blur', required: false }], // 手机号
        storageTankStandard: [{ validator: storageTankStandard, trigger: 'blur', required: false }], // 储罐规格
        storageTankHeight: [{ validator: storageTankHeight, trigger: 'blur', required: false }], // 储罐高度
        storageTankDiameter: [{ validator: storageTankDiameter, trigger: 'blur', required: false }], // 储罐直径
        leasePotCount: [{ validator: leasePotCount, trigger: 'blur', required: false }], // 起租罐数
        tenantablePotCount: [{ validator: tenantablePotCount, trigger: 'blur', required: false }], // 可租罐数
        expectPrice: [{ validator: expectPrice, trigger: 'blur', required: false }], // 租金
        detailedLocation: [
          { required: false, message: '请输入详细位置', trigger: 'blur' },
          { max: 255, message: '最多255位字符' }
        ], // 详细位置
        potArea: [{ validator: potArea, trigger: 'blur', required: false }], // 罐区面积
        fireInformation: [{ validator: this.$character(1, 300, 'checkEmpty'), trigger: 'blur' }], // 消防信息
        remarks: [{ validator: this.$character(1, 200, 'checkEmpty'), trigger: 'blur' }] // 仓库简介
      },
      tankFarmSupplyRules: {
        supplyName: [{ required: true, validator: this.$character(0, 50, 'check'), trigger: 'blur' }], // 租单名称
        storageTankShape: [{ required: true, message: '请选择储罐形状', trigger: 'change' }], // 储罐形状
        storageType: [{ type: 'array', required: true, message: '请至少选择一个储存类型', trigger: 'change' }], // 储存类型
        cargoName: [{ required: true, validator: this.$character(0, 50, 'check'), trigger: 'blur' }], // 货物名称
        leaseTime: [{ required: true, message: '请选择起租日期', trigger: 'change' }], // 起租日期
        companyName: [{ required: true, message: '未认证、请先认证个人信息', trigger: 'blur' }], // 公司名称
        linkMan: [{ required: true, validator: this.$character(0, 20, 'check'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        storageTankStandard: [{ required: true, validator: storageTankStandard }], // 储罐规格
        storageTankHeight: [{ required: true, validator: storageTankHeight }], // 储罐高度
        storageTankDiameter: [{ required: true, validator: storageTankDiameter }], // 储罐直径
        storageTankType: [{ required: true, message: '请选择储罐型号', trigger: 'change' }], // 储罐型号
        leasePotCount: [{ required: true, validator: leasePotCount }], // 起租罐数
        tenantablePotCount: [{ required: true, validator: tenantablePotCount }], // 可租罐数
        expectPrice: [{ required: true, validator: expectPrice }], // 租金
        leaseTerm: [{ required: true, message: '请选择起租年限', trigger: 'change' }], // 起租年限
        storageLocation: [{ required: true, message: '请选择库房位置', trigger: 'change' }], // 库房位置
        detailedLocation: [
          { required: true, message: '请输入详细位置', trigger: 'blur' },
          { max: 255, message: '最多255位字符' }
        ], // 详细位置
        potArea: [{ required: true, validator: potArea }], // 罐区面积
        fireResistanceRating: [{ required: true, message: '请选择罐区耐火等级', trigger: 'change' }], // 罐区耐火级
        fireQualification: [{ required: true, message: '请选择消防资质', trigger: 'change' }], // 消防资质
        fireInformation: [{ required: true, validator: this.$character(0, 200, 'check'), trigger: 'blur' }], // 消防信息
        storageUrl: [
          // { required: true, message: '请上传库房照片', trigger: 'blur' }
        ], // 库房照片(最多可上传6张)
        remarks: [{ required: true, validator: this.$character(0, 200, 'check'), trigger: 'blur' }] // 仓库简介
      },
      map: null
    }
  },
  // 初始化加载 所有资格认证数据
  created() {
    (async() => {
      await this.getArea()
      await this.getStorageType()
      await this.getWarehouseType()
      await this.getFireQualification()
      await this.getStoreEquipment()
      await this.getFloorTexture()
      await this.getLandingPlatform()
      await this.getFireResistanceRating()
      await this.getTankType()
      await this.getStorageTankShape()
      await this.getStorageTankType()
      await this.getLeaseTerm()
      await this.getCompanyInfo()
      this.loading = false
    })()
  },
  methods: {
    // 租单生成
    // nameBlur(ev) {
    // const _this = this
    // setTimeout(function() {
    //   const addres = _this.$refs.addressRelease.value
    //   const arr = []
    //   console.log(_this.area)
    //   if (addres.length == 1) {
    //     for (let j = 0; j < _this.area.length; j++) {
    //       if (_this.area[j].value == addres[0]) {
    //         arr.push(_this.area[j].label)
    //       }
    //     }
    //   }
    //   if (addres.length == 2) {
    //     for (let j = 0; j < _this.area.length; j++) {
    //       if (_this.area[j].children.value == addres[1]) {
    //         arr.push(_this.area[j].label)
    //       }
    //     }
    //   }
    //   for (let i = 0; i < addres.length; i++) {
    //
    //   }
    //   // const con = `${_this.storageSupply.storageLocation}`
    // }, 0)
    // },
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 重置表单
    delsupply() {
      this.storageSupply = {
        supplyName: null, // 租单名称
        warehouseType: null, // 仓库类型
        storageType: [], // 储货类型
        leaseTime: null, // 起租日期
        lettableArea: null, // 起租面积
        rentableArea: null, // 可租用面积
        expectPrice: null, // 租金
        leaseTerm: null, // 起租年限
        storageLocation: null, // 库房位置
        detailedLocation: null, // 详细位置
        coveredArea: null, // 建筑面积
        fireQualification: null, // 消防资质
        warehouseEquipment: null, // 库内设备（多选）
        floorTexture: null, // 地坪质地
        floorWeight: null, // 地坪承重
        landingPlatform: null, // 卸货平台
        storageUrl: '', // 库房照片
        companyId: '212', // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageRecommend: null, // 仓库简介
        remarks: null, // 备注
        publishStatus: null, // 发布状态 1待发布 2已发布
        longLat: null
      }
      this.tankFarmSupply = {
        supplyName: null, // 租单名称
        storageTankShape: null, // 储罐形状
        storageType: [], // 储存类型
        cargoName: null, // 货物名称
        leaseTime: null, // 起租日期
        companyId: '2', // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageTankStandard: null, // 储罐规格
        storageTankHeight: null, // 储罐高度
        storageTankDiameter: null, // 储罐直径
        storageTankType: null, // 储罐型号
        leasePotCount: null, // 起租罐数
        tenantablePotCount: null, // 可租罐数
        expectPrice: null, // 租金
        leaseTerm: null, // 起租年限
        storageLocation: null, // 库房位置
        detailedLocation: null, // 详细位置
        potArea: null, // 罐区面积
        fireResistanceRating: null, // 罐区耐火级
        fireQualification: null, // 消防资质
        fireInformation: null, // 消防信息
        storageUrl: '', // 库房照片(最多可上传6张)
        remarks: null, // 备注
        publishStatus: null, // 发布状态 1已发布 2未发布
        longLat: null
      }
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
      }, 100)
    },
    // 详情位置回调
    handleSelect(item) {
      const con = item.location.lat + ',' + item.location.lng
      this.storageSupply.longLat = con
      this.tankFarmSupply.longLat = con
    },
    // 地图定位查询
    querySearch(queryString, cb) {
      const addres = this.activeName == 'first' ? this.storageSupply.storageLocation : this.tankFarmSupply.storageLocation
      if (addres == null || addres == '') {
        var isError = document.getElementsByClassName(this.activeName == 'first' ? 'storageLocation' : 'tankStorageLocation')
        this.activeName == 'first' ? this.storageSupply.detailedLocation = '' : this.tankFarmSupply.detailedLocation = ''
        isError[0].querySelector('input').focus()
        cb([])
        this.$message({
          message: '请先选择库房位置!',
          offset: 100,
          type: 'warning'
        })
        // this.isErrorShow('请先选择库房位置!')
        return
      }
      if (queryString == null || queryString == '') {
        cb([])
        return
      }
      var results = []
      // const map = this.map
      AMap.service(['AMap.PlaceSearch'], () => {
      // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          // city: '邹平', // 兴趣点城市
          city: addres[addres.length - 1],
          citylimit: true // 是否强制限制在设置的城市内搜索
          // map: map // 展现结果的地图实例
        // panel: 'panel', // 结果列表将在此容器中进行展示。
        // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })

        // 关键字查询
          placeSearch.search(queryString, (status, result) => {
            // alert(JSON.stringify(b))
            // console.log(JSON.stringify(status))
            if (status == 'complete') {
              result.poiList.pois.forEach(element => {
                results.push({ 'title': element.name, 'value': element.address + element.name, 'address': element.address, 'location': element.location })
              })
              cb(results)
            } else {
              this.activeName == 'first' ? this.storageSupply.detailedLocation = '' : this.tankFarmSupply.detailedLocation = ''
              cb(results)
              this.$message({
                message: '暂无数据!',
                offset: 100,
                type: 'warning'
              })
              // this.isErrorShow('暂无数据!')
              // cb(results)
            }
          })
        })
    },
    // 详情地址错误提示
    isErrorShow(errName) {
      var className = this.activeName == 'first' ? 'detailedLocation' : 'tankDetailedLocation'
      setTimeout(function() {
        var isDetailsError = document.getElementsByClassName(className)
        var detaError = isDetailsError[0].querySelector('.el-form-item__error')
        if (!detaError) {
          var autocomplete = isDetailsError[0].querySelector('.el-form-item__content')
          var btn = document.createElement('div')
          var att = document.createAttribute('class')
          att.value = 'el-form-item__error'
          btn.setAttributeNode(att)
          var t = document.createTextNode(errName)
          btn.appendChild(t)
          autocomplete.appendChild(btn)
          // var t=document.createTextNode("CLICK ME");
        } else {
          detaError.innerHTML = errName
        }
      }, 100)
    },
    // 查询企业信息
    getCompanyInfo() {
      getCompanyInfo()
        .then(data => {
          console.log('11111111111111',data)
          this.storageSupply.linkMan = data.user.companyContact
          this.storageSupply.telephone = data.user.phone
          this.storageSupply.companyId = data.result.id
          this.storageSupply.companyName = data.user.companyName
          this.tankFarmSupply.linkMan = data.user.companyContact
          this.tankFarmSupply.telephone = data.user.phone
          this.tankFarmSupply.companyId = data.result.id
          this.tankFarmSupply.companyName = data.user.companyName       
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType').then((storageType) => {
        if (storageType.length > 0) {
          storageType.forEach(res => {
            this.storageType.storageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageType').then(res => {
          const storageType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageType', storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 仓库类型字典
    getWarehouseType() {
      this.getLocalStorageUtil('warehouseType').then((warehouseType) => {
        if (warehouseType.length > 0) {
          warehouseType.forEach(res => {
            this.storageType.warehouseType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('warehouseType').then(res => {
          const warehouseType = JSON.parse(res.result)
          this.setLocalStorageUtil('warehouseType', warehouseType)
          if (warehouseType.length > 0) {
            warehouseType.forEach(res => {
              this.storageType.warehouseType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 消防资质字典
    getFireQualification() {
      this.getLocalStorageUtil('fireQualification').then((fireQualification) => {
        if (fireQualification.length > 0) {
          fireQualification.forEach(res => {
            this.storageType.fireQualification.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireQualification').then(res => {
          const fireQualification = JSON.parse(res.result)
          this.setLocalStorageUtil('fireQualification', fireQualification)
          if (fireQualification.length > 0) {
            fireQualification.forEach(res => {
              this.storageType.fireQualification.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 库内设备字典
    getStoreEquipment() {
      this.getLocalStorageUtil('storeEquipment').then((storeEquipment) => {
        if (storeEquipment.length > 0) {
          storeEquipment.forEach(res => {
            this.storageType.storeEquipment.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storeEquipment').then(res => {
          const storeEquipment = JSON.parse(res.result)
          this.setLocalStorageUtil('storeEquipment', storeEquipment)
          if (storeEquipment.length > 0) {
            storeEquipment.forEach(res => {
              this.storageType.storeEquipment.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 地坪质地字典
    getFloorTexture() {
      this.getLocalStorageUtil('floorTexture').then((floorTexture) => {
        if (floorTexture.length > 0) {
          floorTexture.forEach(res => {
            this.storageType.floorTexture.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('floorTexture').then(res => {
          const floorTexture = JSON.parse(res.result)
          this.setLocalStorageUtil('floorTexture', floorTexture)
          if (floorTexture.length > 0) {
            floorTexture.forEach(res => {
              this.storageType.floorTexture.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 卸货平台字典
    getLandingPlatform() {
      this.getLocalStorageUtil('landingPlatform').then((landingPlatform) => {
        if (landingPlatform.length > 0) {
          landingPlatform.forEach(res => {
            this.storageType.landingPlatform.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('landingPlatform').then(res => {
          const landingPlatform = JSON.parse(res.result)
          this.setLocalStorageUtil('landingPlatform', landingPlatform)
          if (landingPlatform.length > 0) {
            landingPlatform.forEach(res => {
              this.storageType.landingPlatform.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区耐火等级字典
    getFireResistanceRating() {
      this.getLocalStorageUtil('fireResistanceRating').then((fireResistanceRating) => {
        if (fireResistanceRating.length > 0) {
          fireResistanceRating.forEach(res => {
            this.storageType.fireResistanceRating.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireResistanceRating').then(res => {
          const fireResistanceRating = JSON.parse(res.result)
          this.setLocalStorageUtil('fireResistanceRating', fireResistanceRating)
          if (fireResistanceRating.length > 0) {
            fireResistanceRating.forEach(res => {
              this.storageType.fireResistanceRating.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区储存类型字典
    getTankType() {
      this.getLocalStorageUtil('tankType').then((tankType) => {
        if (tankType.length > 0) {
          tankType.forEach(res => {
            this.storageType.tankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('tankType').then(res => {
          const tankType = JSON.parse(res.result)
          this.setLocalStorageUtil('tankType', tankType)
          if (tankType.length > 0) {
            tankType.forEach(res => {
              this.storageType.tankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 储罐形状类型字典
    getStorageTankShape() {
      this.getLocalStorageUtil('storageTankShape').then((storageTankShape) => {
        if (storageTankShape.length > 0) {
          storageTankShape.forEach(res => {
            this.storageType.storageTankShape.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageTankShape').then(res => {
          const storageTankShape = JSON.parse(res.result)
          this.setLocalStorageUtil('storageTankShape', storageTankShape)
          if (storageTankShape.length > 0) {
            storageTankShape.forEach(res => {
              this.storageType.storageTankShape.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 储罐型号类型字典
    getStorageTankType() {
      this.getLocalStorageUtil('storageTankType').then((storageTankType) => {
        if (storageTankType.length > 0) {
          storageTankType.forEach(res => {
            this.storageType.storageTankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageTankType').then(res => {
          const storageTankType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageTankType', storageTankType)
          if (storageTankType.length > 0) {
            storageTankType.forEach(res => {
              this.storageType.storageTankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 起租年限类型字典
    getLeaseTerm() {
      this.getLocalStorageUtil('leaseTerm').then((leaseTerm) => {
        if (leaseTerm.length > 0) {
          leaseTerm.forEach(res => {
            this.storageType.leaseTerm.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('leaseTerm').then(res => {
          const leaseTerm = JSON.parse(res.result)
          this.setLocalStorageUtil('leaseTerm', leaseTerm)
          if (leaseTerm.length > 0) {
            leaseTerm.forEach(res => {
              this.storageType.leaseTerm.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    storageSupplySave(rulesForm, status) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            // console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const supply = JSON.parse(JSON.stringify(this.storageSupply))
          supply.publishStatus = status
          if (this.storageSupply) {
            if (this.storageSupply.storageLocation && Object.prototype.toString.call(this.storageSupply.storageLocation).indexOf('Array') !== -1 && this.storageSupply.storageLocation.length > 0) {
              supply.storageLocation = this.storageSupply.storageLocation.join('#')
            }
            if (this.storageSupply.storageType) {
              supply.storageType = this.storageSupply.storageType.toString()
            }
            if (this.storageSupply.warehouseEquipment) {
              supply.warehouseEquipment = this.storageSupply.warehouseEquipment.toString()
            }
          }
          // console.log(supply)
          createInfo(supply).then((result) => {
            
            // 成功提示
            this.$message({
              showClose: true,
              offset: 100,
              message: status == '1' ? '普仓信息，保存成功' : '普仓信息，发布成功',
              type: 'success'
            })
            this.post_flag = false
            this.$router.push({ name: 'StoreSupplyList' })
            
            setTimeout(() => {
              this.delsupply()
            }, 1000)
          }).catch((err) => {
            console.log(err)
            this.post_flag = false
          })
        } else {
          // 失败返回数据
          setTimeout(() => {
            var isError = document.getElementsByClassName(`${this.activeName}-error`)[0].getElementsByClassName('is-error')
            if (isError[0].querySelector('input').type == 'file') {
              isError[0].querySelector('input').style.display = 'block'
              isError[0].querySelector('input').focus()
              isError[0].querySelector('input').style.display = 'none'
            } else {
              isError[0].querySelector('input').focus()
            }
          }, 1)
          return false
        }
      })
    },
    tankFarmSupplySave(rulesForm, status) {
      console.log(111111)
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            // console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const supply = JSON.parse(JSON.stringify(this.tankFarmSupply))
          if (this.tankFarmSupply) {
            if (this.tankFarmSupply.storageLocation && Object.prototype.toString.call(this.tankFarmSupply.storageLocation).indexOf('Array') !== -1 && this.tankFarmSupply.storageLocation.length > 0) {
              supply.storageLocation = this.tankFarmSupply.storageLocation.join('#')
            }
            if (this.tankFarmSupply.storageType) {
              supply.storageType = this.tankFarmSupply.storageType.join(',')
            }
          }
          supply.publishStatus = status
          createTankFarmInfo(supply).then((result) => {
          console.log(result) 
            // 成功提示
            this.$message({
              showClose: true,
              offset: 100,
              message: status == '1' ? '罐区信息，保存成功' : '罐区信息，发布成功',
              type: 'success'
            })
            this.post_flag = false
            this.$router.push({ name: 'TankSupplyList' })
            setTimeout(() => {
              this.delsupply()
            }, 1000)
          }).catch((err) => {
            console.log(err)
            this.post_flag = false
          })
        } else {
          // 失败返回数据
          setTimeout(() => {
            var isError = document.getElementsByClassName(`${this.activeName}-error`)[0].getElementsByClassName('is-error')
            if (isError[0].querySelector('input').type == 'file') {
              isError[0].querySelector('input').style.display = 'block'
              isError[0].querySelector('input').focus()
              isError[0].querySelector('input').style.display = 'none'
            } else {
              isError[0].querySelector('input').focus()
            }
          }, 1)
          return false
        }
      })
    },
    // 表单切换监听
    handleClick(tab, event) {
      if (tab.index === '0') {
        this.$refs['storageSupply'].clearValidate()
      } else {
        this.$refs['tankFarmSupply'].clearValidate()
      }
    },
    // 分页监听
    handleCheckAllChange(val) {
      const cityOptionsList = []
      this.storageType.storageType.forEach(res => {
        cityOptionsList.push(res.value)
      })
      this.storageSupply.storageType = val ? cityOptionsList : []
      this.isIndeterminate = false
    },
    // 分页监听
    handleCheckedCitiesChange(value) {
      const cityOptionsList = []
      this.storageType.storageType.forEach(res => {
        cityOptionsList.push(res.value)
      })
      const checkedCount = value.length
      this.checkAll = checkedCount === cityOptionsList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < cityOptionsList.length
    }
  }
}
</script>
<style scoped lang='scss'>
  @import "@/styles/standardColor.scss";
  .my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
  /deep/.el-input-group__append, .el-input-group__prepend {
      background-color: #ffffff;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #DCDFE6;
      border-left: 0;
      border-radius: 0px;
      padding: 0 10px;
      width: 1px;
      white-space: nowrap;
  }

  $prefix: "el-tabs__";
  /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before  {
    content: '*';
    color: #be2316;
    font-size: 16px;
    margin-right: 4px;
  }
  input__inner {
    background-color: white;
    border-radius: 0px;
    border: 0;
    border-bottom: 1px solid gainsboro;
  }
  /deep/.el-input input{
    border-radius:0px;
  }
  /deep/.checkboxSty .el-input .el-input__inner , /deep/.el-textarea .el-textarea__inner{
    border-radius:0px;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  /deep/.checkboxSty{
    width:100%;
  }
  /deep/.sfSty{
    color:#409EFF
  }
  /deep/.sfSty:hover{
    color: #8c939d
  }
  /deep/.el-select{
    width:100%;
  }
  /deep/.el-card .el-card__body{
    display: grid;
    padding: 4rem;
  }
  // #{prefix}
  /deep/.is-active{
    color:#BE2316;
    font-size: 18px;
    font-weight: bold;
  }
  /deep/.el-tabs__item{
    font-size: 18px;
    font-weight: bold;
  }
  /deep/.el-tabs__item:hover {
    color: #BE2316;
    cursor: pointer;
  }
  /deep/.el-tabs__active-bar{
    background-color: #BE2316;
    height: 1px;
  }
  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #E4E7ED;
    z-index: 1;
  }
  /deep/.el-form.el-form--label-right .el-form-item__content {
    margin-left: 0rem;
  }
  .el-button-ml{
    margin-left: 35%;
    width: 35%;
    height: 40px;
    margin-top: 50px;
    font-size: 18px;
    background-color: #BE2316;
    margin-bottom: 10%
  }
  .menu-head {
    display: flex;
    margin: 1rem;
    padding-bottom: 1rem;
    border-style: dashed;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    .head-color {
      width: 5px;
      height: 18px;
      background-color: #be2316;
      border-radius: 5px;
      margin-right: 1rem;
    }
    font-size: 18px;
    font-weight: bold;
  }
  .main-wrap{
    width: 100%;
    background-color: white;
    margin-top: -15px;
  }
</style>

